// ---------------------------------------------------
// 2. Constants for Reusable Colors (All Hex Values, including Opacity)
// ---------------------------------------------------
// Alpha values (0-255) in hex:
// 100% -> FF, 75% -> BF, 50% -> 80, 25% -> 40, 15% -> 26, 8% -> 14
interface PaletteColor {
  light?: string;
  dark?: string;
  contrastText?: string;

  main: string;

  o75?: string;
  o50?: string;
  o25?: string;
}

const ColorPrimary: PaletteColor = {
  main: '#012231',
  light: '#BFE5D7',
  dark: '#93CAB7',
  contrastText: '#FFFFFF',
};

const ColorSecondary: PaletteColor = {
  main: '#F09A37',
  light: '#FAE0C3',
  dark: '#F7CC9B',
  contrastText: '#FFFFFF',
};

const ColorInfo: PaletteColor = {
  main: '#008256',
  light: '#339B77',
  dark: '#005B3C',
  contrastText: '#FFFFFF',
};

const ColorSuccess: PaletteColor = {
  main: '#008256',
  light: '#339B77',
  dark: '#005B3C',
  contrastText: '#FFFFFF',
};

const ColorError: PaletteColor = {
  main: '#D61134',
  light: '#EA889A',
  dark: '#E34843',
  contrastText: '#FFFFFF',
};

const ColorWarning: PaletteColor = {
  main: '#FF9330',
  light: '#FFAE64',
  dark: '#B26621',
  contrastText: '#FFFFFF',
};

const ColorBlue: PaletteColor = {
  main: '#98C9EB',
  o75: '#BADBF2',
  o50: '#D6E9F7',
  o25: '#E6F2FA',
};

const ColorPurple: PaletteColor = {
  main: '#614B79',
  light: '#BFB7C9',
  contrastText: '#FFFFFF',
};

const ColorGray: PaletteColor = {
  main: '#999999',
  light: '#CCCCCC',
  dark: '#666666',
  o25: '#DFE7EC',
};

const ColorLightGreen: PaletteColor = {
  main: '#ECF2EE',
  light: '#CEEFDB',
  dark: '#CCE6DD',
  contrastText: '#333333',
};

const ColorLightGray: PaletteColor = {
  main: '#E0E0E0',
  light: '#EEEEEE',
  dark: '#999999',
  contrastText: '#333333',
};

// BluViu colors
const ColorBluViu: PaletteColor = {
  main: '#005B83',
  o75: '#437A9C',
  o50: '#729BB4',
  o25: '#B8CCDA',
  dark: '#002E42',
};

const ColorDarkBlue: PaletteColor = {
  main: '#012231',
  o75: '#415965',
  o50: '#809198',
  o25: '#C0C8CC',
  light: '#E0E4E6',
  contrastText: '#5A7179',
}; //light is used in the data grid

const ColorBeige: PaletteColor = {
  main: '#DEBFA2',
  o75: '#E6CFB9',
  o50: '#EFDFD1',
  o25: '#F7EFE8',
};

const ColorLightBlue: PaletteColor = {
  main: '#98C9EB',
  o75: '#BADBF2',
  o50: '#D6E9F7',
  o25: '#E6F2FA',
  // old

  light: '#EEF3FA',
  dark: ColorBluViu.main,
  contrastText: ColorBluViu.main,
};

const ColorGreen: PaletteColor = {
  main: '#019776',
  o75: '#52BDA6',
  o50: '#97D7CA',
  o25: '#DCF2ED',
  // old

  light: '#CEEFDB',
  contrastText: '#FFFFFF',
  dark: '#004234',
};

const ColorRed: PaletteColor = {
  main: '#D61134',
  o75: '#C55468',
  o50: '#EA889A',
  o25: '#F5B2BE',
  // old

  light: '#FADCDE',
  contrastText: '#FFFFFF',
};

const ColorOrange: PaletteColor = {
  main: '#FF9330',
  o75: '#FFAE64',
  // old
  light: '#FFEAD6',
  contrastText: '#FFFFFF',

  o50: '#FFC998',
  dark: '#DB7B00',
  o25: '#FFECD0',
};

export {
  ColorBeige,
  ColorBlue,
  ColorBluViu,
  ColorDarkBlue,
  ColorError,
  ColorGray,
  ColorGreen,
  ColorInfo,
  ColorLightBlue,
  ColorLightGray,
  ColorLightGreen,
  ColorOrange,
  ColorPrimary,
  ColorPurple,
  ColorRed,
  ColorSecondary,
  ColorSuccess,
  ColorWarning,
};
